import styled from 'styled-components'

export const CheckAllContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  align-items: center;
  padding-left: ${props => props.theme.spacing.sp8};
`
